import React, { useState } from "react";
import axios from "axios";
import { API } from "../atlas/helpers";

export function LoginScreen({ onLogin }) {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;

    setLoading(true);
    setError(null);

    try {
      // Test the code against the backend verify endpoint
      const res = await axios.post(`${API}/auth/verify`, { code: code.trim() });
      if (res.data?.valid) {
        localStorage.setItem("atlas_access_code", code.trim());
        if (res.data.role) {
          localStorage.setItem("atlas_role", res.data.role);
        }
        onLogin();
      } else {
        setError("Invalid access code.");
      }
    } catch (err) {
      if (err.response?.status === 401) {
        setError("Invalid access code.");
      } else {
        setError("Cannot reach Atlas backend. Check connection.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      width: "100vw", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
      background: "radial-gradient(circle at center, #0a0d14 0%, #050608 100%)",
      color: "var(--text-primary)", fontFamily: "var(--font-sans)"
    }}>
      <div style={{
        width: 380, padding: 40, borderRadius: 16, background: "rgba(255,255,255,0.02)",
        border: "1px solid rgba(255,255,255,0.05)", backdropFilter: "blur(20px)",
        boxShadow: "0 24px 64px rgba(0,0,0,0.4)", display: "flex", flexDirection: "column", alignItems: "center"
      }}>
        {/* Logo/Icon placeholder */}
        <div style={{
          width: 48, height: 48, borderRadius: "50%", background: "var(--blue-glow)",
          display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 24,
          boxShadow: "0 0 20px var(--blue-glow)"
        }}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="var(--blue)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="12 2 2 22 22 22"></polygon>
          </svg>
        </div>
        
        <h1 style={{ fontSize: 24, fontWeight: 600, margin: "0 0 8px 0", letterSpacing: "-0.02em" }}>Atlas Terminal</h1>
        <p style={{ color: "var(--text-secondary)", fontSize: 13, marginBottom: 32, textAlign: "center" }}>
          Secure system access required.
        </p>

        <form onSubmit={handleSubmit} style={{ width: "100%", display: "flex", flexDirection: "column", gap: 16 }}>
          <div>
            <input
              type="password"
              placeholder="Enter Access Code"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              disabled={loading}
              style={{
                width: "100%", padding: "12px 16px", borderRadius: 8, background: "rgba(0,0,0,0.2)",
                border: "1px solid var(--border-dim)", color: "white", fontSize: 14,
                outline: "none", transition: "border-color 0.2s"
              }}
              onFocus={(e) => e.target.style.borderColor = "var(--blue)"}
              onBlur={(e) => e.target.style.borderColor = "var(--border-dim)"}
            />
          </div>

          {error && <div style={{ color: "var(--red)", fontSize: 12, textAlign: "center" }}>{error}</div>}

          <button
            type="submit"
            disabled={loading || !code.trim()}
            style={{
              width: "100%", padding: "12px", borderRadius: 8, background: "var(--blue)", color: "white",
              fontWeight: 600, fontSize: 14, border: "none", cursor: loading || !code.trim() ? "not-allowed" : "pointer",
              opacity: loading || !code.trim() ? 0.7 : 1, transition: "opacity 0.2s"
            }}
          >
            {loading ? "Verifying..." : "Initialize Uplink"}
          </button>
        </form>
      </div>
    </div>
  );
}
